//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.AdyenPaymentMethod
import com.tixforgigs.apax.models.Amount

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The adyen session model
* 
* @param allowedPaymentMethods The allowed payment methods
* @param applePayMerchantIdentifier The apple pay merchant id
* @param clientKey The adyen client key
* @param environment The adyen environment TEST/PROD
* @param id The adyen session id
* @param merchantId The adyen merchant id
* @param sessionData The adyen session data
* @param subTotal 
*/
@Serializable

data class AdyenSession (


      /* The allowed payment methods */
    @SerialName(value = "allowedPaymentMethods") @Required val allowedPaymentMethods: kotlin.collections.Set<AdyenPaymentMethod>,


      /* The apple pay merchant id */
    @SerialName(value = "applePayMerchantIdentifier") @Required val applePayMerchantIdentifier: kotlin.String,


      /* The adyen client key */
    @SerialName(value = "clientKey") @Required val clientKey: kotlin.String,


      /* The adyen environment TEST/PROD */
    @SerialName(value = "environment") @Required val environment: kotlin.String,


      /* The adyen session id */
    @SerialName(value = "id") @Required val id: kotlin.String,


      /* The adyen merchant id */
    @SerialName(value = "merchantId") @Required val merchantId: kotlin.String,


      /* The adyen session data */
    @SerialName(value = "sessionData") @Required val sessionData: kotlin.String,


      @SerialName(value = "subTotal") @Required val subTotal: Amount


) {




  }

